import { Tooltip } from "@chakra-ui/react";
import { UserId } from "features/User/models";
import { useUserDetailQuery } from "features/User/hooks";
import ResourceTargetAvatar from "features/Resources/SharedTemplate/Components/ResourceTargetAvatar";

interface SenderTagProps {
  senderId?: UserId;
}

export default function SenderTag({ senderId }: SenderTagProps) {
  const { data: user } = useUserDetailQuery(senderId || "", {
    enabled: !!senderId,
  });

  const tooltipLabel = user ? (user as any).fullName : "Camino";
  const img = user ? (user as any).avatarUrl : "favico.ico";

  return (
    <Tooltip label={tooltipLabel} placement="top">
      <ResourceTargetAvatar name={tooltipLabel} src={img} />
    </Tooltip>
  );
}
